import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'price',
  standalone: true,
})
export class PricePipe implements PipeTransform {
  transform(value: any): string {
    const num = Number(value);
    if (isNaN(num)) {
      return '';
    }
    return num.toFixed(2);
  }
}
